module.exports = __webpack_public_path__ + "static/media/thumbnail-quartos.701b3057.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbnail-quartos.png
// module id = 400
// module chunks = 0